export const ADD_CHAPTER_COMMENT_REQUEST = "ADD_CHAPTER_COMMENT_REQUEST";
export const ADD_CHAPTER_COMMENT_SUCCESS = "ADD_CHAPTER_COMMENT_SUCCESS";
export const ADD_CHAPTER_COMMENT_FAILURE = "ADD_CHAPTER_COMMENT_FAILURE";

export const ADD_COMMENT_REPLY_REQUEST = "ADD_COMMENT_REPLY_REQUEST";
export const ADD_COMMENT_REPLY_SUCCESS = "ADD_COMMENT_REPLY_SUCCESS";
export const ADD_COMMENT_REPLY_FAILURE = "ADD_COMMENT_REPLY_FAILURE";

export const GET_CHAPTER_COMMENTS_REQUEST = "GET_CHAPTER_COMMENTS_REQUEST";
export const GET_CHAPTER_COMMENTS_SUCCESS = "GET_CHAPTER_COMMENTS_SUCCESS";
export const GET_CHAPTER_COMMENTS_FAILURE = "GET_CHAPTER_COMMENTS_FAILURE";

export const RESET_ALL_COMMENT_STATE = "RESET_ALL_COMMENT_STATE";
